const cronjobs = {
  rows: [
    {
      command: 'path',
      day: '*',
      hour: '*',
      key: 1952517936,
      line: 3,
      minute: '*',
      month: '*',
      type: 'command',
      weekday: '*',
    },
    {
      command: 'path2',
      day: '*',
      hour: '*',
      key: 919248934,
      line: 4,
      minute: '*',
      month: '*',
      type: 'command',
      weekday: '*',
    },
    {
      command: 'doodahdah',
      day: '*',
      hour: '*',
      key: 641702109,
      line: 5,
      minute: '*',
      month: '*',
      type: 'command',
      weekday: '*',
    },
    {
      command: 'qatestmarch3123',
      day: '15',
      hour: '*',
      key: 904086672,
      line: 6,
      minute: '30',
      month: '*',
      type: 'command',
      weekday: '*',
    },
    {
      command: 'qatestmarch3132',
      day: '*',
      hour: '*',
      key: 2158681685,
      line: 7,
      minute: '*',
      month: '*',
      type: 'command',
      weekday: '*',
    },
    {
      command: 'something',
      day: '2',
      hour: '*',
      key: 1026530401,
      line: 8,
      minute: '*',
      month: '*',
      type: 'command',
      weekday: '*',
    },
  ],
  email: 'ue8wycdldyobcwnb@ue8wycdldyobcwnb.com',
};

export default cronjobs;
